import { cameraSchema } from '@sophocles/entities/Camera';
import { radioSchema } from '@sophocles/entities/Radio';
import { List, Record } from 'immutable';
import { schema } from 'normalizr';

export const CameraInterfaceController = new Record({
  id: undefined,
  site: undefined,
  relay_controller: undefined,
  radio: undefined,
  cameras_installed: undefined,
  alarm_delay: undefined,
  alarm_interval: undefined,
  alarm_photo_count: undefined,
  minimum_time_between_alarms: undefined,
  data_session_timeout: undefined,
  check_in_time: undefined,
  last_status_received_at: undefined,
  cameras: List(),
});

export const cameraInterfaceControllerSchema = new schema.Entity('cameraInterfaceControllers', {
  cameras: [cameraSchema],
  radio: radioSchema,
});
